import { Body1, Button, Spinner, Title1, makeStyles, tokens } from '@fluentui/react-components';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthProvider';
import { MeProvider } from './auth/MeProvider';
import { Layout } from './components/Layout';
import { Activity } from './pages/Activity';
import { Callback } from './pages/Callback';
import { Devices } from './pages/Devices';
import { Firewall } from './pages/Firewall';
import { NetworkMap } from './pages/NetworkMap';
import { Networks } from './pages/Networks';
import { Overview } from './pages/Overview';
import { Sites } from './pages/Sites';
import { Traffic } from './pages/Traffic';

const useStyles = makeStyles({
  centered: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: tokens.spacingVerticalL,
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground1,
    padding: tokens.spacingHorizontalXL,
    textAlign: 'center',
  },
});

/** Gate: loading spinner, then either the sign-in screen or the signed-in shell. */
function Protected() {
  const s = useStyles();
  const { status, signIn } = useAuth();
  const { pathname, search } = useLocation();

  if (status === 'loading') {
    return (
      <div className={s.centered}>
        <Spinner label="Loading" />
      </div>
    );
  }
  if (status === 'signedOut') {
    // An explicit button rather than an automatic redirect: a failing IAM would otherwise
    // bounce the browser in a loop, and sign-out lands here too.
    return (
      <div className={s.centered}>
        <Title1>VIPPER Infrastructure Console</Title1>
        <Body1>Sign in with your VIPPER account to continue.</Body1>
        <Button appearance="primary" size="large" onClick={() => void signIn(pathname + search)}>
          Sign in
        </Button>
      </div>
    );
  }
  return (
    <MeProvider>
      <Layout />
    </MeProvider>
  );
}

export function App() {
  return (
    <Routes>
      <Route path="/callback" element={<CallbackShell />} />
      <Route element={<Protected />}>
        <Route index element={<Overview />} />
        <Route path="map" element={<NetworkMap />} />
        <Route path="devices" element={<Devices />} />
        <Route path="networks" element={<Networks />} />
        <Route path="firewall" element={<Firewall />} />
        <Route path="traffic" element={<Traffic />} />
        <Route path="activity" element={<Activity />} />
        <Route path="sites" element={<Sites />} />
        {/* The pre-mockup console kept relay and devices under /vpn. */}
        <Route path="vpn" element={<Navigate to="/devices" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function CallbackShell() {
  const s = useStyles();
  return (
    <div className={s.centered}>
      <Callback />
    </div>
  );
}
